import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';
import { appStateSelectors } from './redux';

const query = gql`
  query info {
    siteName
    me {
      dbVersion
    }
  }
`;

interface Query {
  siteName: string;
  me: {
    dbVersion: number;
  };
}

export const UseDingoGetItemDetailsStoreLimit = 10;

export const useDingoGetInfo = () => {
  const isLoggedIn = useSelector(appStateSelectors.getIsLoggedIn);
  return useQuery<Query>(query, {
    fetchPolicy: 'network-only',
    skip: !isLoggedIn,
  });
};
